<template>
  <div
    class="outline uk-panel uk-height-1-1"
    ref="outlineContainer"
    id="outlineContainer"
    @mouseup="doOutlinePanelMouseUp"
  >
    <TransitionScroller
      ref="virtualScrollContainer"
      id="outlineVirtualScrollContainer"
      class="uk-height-1-1 annotatorArticleData"
    >
      <div
        id="annotatorOutline"
        class="uk-padding uk-height-1-1 custom-height"
        :class="{ 'outline-full-view-height': isFullView }"
        :style="isFullView ? `height:${OutlineHeight()}px` : ''"
      >
        <div
          class="view-heading uk-flex uk-flex-between uk-padding-small uk-padding-remove-top uk-padding-remove-left uk-margin-small-bottom uk-flex-middle"
        >
          <h5
            class="uk-text-bold uk-padding-remove-top uk-padding-remove-left uk-margin-remove-bottom"
          >
            {{ heading }}
          </h5>
          <div class="invisible-divider"></div>
        </div>
        <OutlineTreeInput
          ref="outlineInput"
          :outlineSource="outlineSource"
          :enableInput="canEditOutline && permissionLevel !== PermissionLevel.COHORT"
          :virtualScrollContainer="scroll"
          :draggable="canEditOutline || roundStatus === RoundStatus.EDITING_NLP_OUTLINE"
          :deleteNode="roundStatus === RoundStatus.EDITING_NLP_OUTLINE"
          @markupClick="$emit('markupClick', $event)"
          @geometriesUpdated="$emit('geometriesUpdated', $event)"
          @dblclick="id => $emit('dblclick', id)"
          @textClick="data => $emit('textClick', data)"
          :isFullView="isFullView"
        />
      </div>
    </TransitionScroller>
  </div>
</template>

<script>
import RoundStatus from '@/assets/js/enum/RoundStatus';
import { mapActions, mapGetters } from 'vuex';
import TransitionScroller from '@/components/general/TransitionScroller';
import OutlineTreeInput from '../annotations/OutlineTreeInput.vue';
import { EventBus } from '@/assets/js/event-bus';
import PermissionLevel from '@/assets/js/enum/PermissionLevel';
export default {
  name: 'OutlinePanel',

  components: {
    TransitionScroller,
    OutlineTreeInput,
  },

  props: {
    outlineSource: Object,

    draggable: {
      type: Boolean,
      default: false,
    },

    isFullView: {
      type: Boolean,
      default: false,
    },

    heading: {
      type: String,
      default: 'Outline View',
    },
  },

  data() {
    return {
      geometries: {},
      sourceElementContainerBoundary: 0,
      scroll: {},
      isUpdated: 0,
    };
  },

  emits: ['textClick'],

  computed: {
    EventBus() {
      return EventBus;
    },
    RoundStatus() {
      return RoundStatus;
    },
    PermissionLevel() {
      return PermissionLevel;
    },

    ...mapGetters([
      'canEditOutline',
      'documentStatus',
      'useExcerpts',
      'roundStatus',
      'permissionLevel',
    ]),

    outlineDepth: function () {
      return 2;
    },
  },

  mounted() {
    this.scroll = this.$refs.virtualScrollContainer;
    EventBus.on('updateoutline', this.updateOutlineDate);
  },

  beforeUnmount() {
    EventBus.off('updateoutline', this.updateOutlineDate);
  },

  methods: {
    ...mapActions(['resetMenu']),
    updateOutlineDate() {
      this.isUpdated++;
    },
    showLevel() {
      let initialDepth = 1;
      let targetDepth = this.$refs.levelSelect.selectedOptions[0].value;
      this.outline.forEach(n => {
        this.setOpenNode(n, initialDepth, targetDepth);
      });
    },

    expandAll() {
      this.$refs.levelSelect.selectedIndex = this.$refs.levelSelect.options.length - 1;
      this.showLevel();
    },

    collapseAll() {
      this.$refs.levelSelect.selectedIndex = 0;
      this.showLevel();
    },

    setOpenNode(node, depth, targetDepth) {
      node.open = depth < targetDepth;
      if (node.children && node.children.length > 0)
        node.children.forEach(n => this.setOpenNode(n, depth + 1, targetDepth));
    },

    doOutlinePanelMouseUp(ev) {
      let index = (
        this.outlineSource?.outline?.outline
          ? this.outlineSource.outline.outline
          : this.outlineSource.outline
      ).findIndex(node => ev.target.id.includes(node._id));
      if (!this.useExcerpts) {
        this.$emit('textClick', {
          event: ev,
          selection: window.getSelection(),
          target: {
            ref: this,
            type: 'outlineNode',
            index: index,
          },
        });
      } else {
        this.resetMenu(false);
      }
    },

    getScroller() {
      return this.$refs.virtualScrollContainer;
    },

    OutlineHeight() {
      return document.getElementById('annotatorOutline')?.scrollHeight - 2;
    },
  },
};
</script>
<style lang="sass" scoped>
.custom-height
  min-height: calc(100vh - 165px)!important
</style>
